import { dataVisualisation } from '#src/palette.ts';
import type { ColorMode } from '#src/components/ColorModeProvider/ColorModeProvider.tsx';

const palette = dataVisualisation;

export const colorise = (
  colorMode: ColorMode,
  datasets: Array<{
    label: string;
    metrics: { total: number; percent: number };
    data: Array<{ x: string; y: number | null }>;
  }>,
) => {
  const colors = palette[colorMode];

  if (datasets.length > colors.length) {
    throw new Error('Too many datasets');
  }

  const colorIndices = datasets.map(
    (dataset) =>
      (dataset.label?.toString() ?? '')
        .split('')
        .reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) % 2 ** 32, 0) %
      colors.length,
  );

  const used = new Set<number>();

  for (let i = 0; i < colorIndices.length; i++) {
    const index = colorIndices[i];
    if (!used.has(index)) {
      used.add(index);
      continue;
    }

    let j = 1;

    while (used.has((index + j) % colors.length)) {
      j++;
    }

    colorIndices[i] = (index + j) % colors.length;
    used.add(colorIndices[i]);
  }

  return datasets.map((dataset, i) => ({
    ...dataset,
    borderColor: colors[colorIndices[i]],
    backgroundColor: colors[colorIndices[i]],
  }));
};
